var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Create new databank",
        label: "Create databank",
        disabled: _vm.isDisabledSubmit,
        submitLoading: _vm.submitLoading
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onCreate
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-5 px-8 overflow-y-auto",
          style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _c(
            "div",
            { staticClass: "grid items-center grid-cols-6 gap-4 py-4" },
            [
              _c("BlInputText", {
                staticClass: "col-span-6",
                attrs: { input: _vm.databankNameInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("BlInputText", {
                staticClass: "col-span-6",
                attrs: { input: _vm.descriptionInput },
                on: { changed: _vm.inputHandler }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-787db9c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787db9c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/databanks/NewDatabankModal.vue
// module id = null
// module chunks = 